export default class ProcessadorFluxos {
    constructor({ mapaCondicoes }) {
        this.mapaCondicoes = mapaCondicoes;
    }

    async avaliarCondicao({ condicao, dados }) {
        if (condicao === undefined || condicao === null) {
            return true;
        }
        let tipoCond = condicao.tipo;
        let processadorCondicao = this.mapaCondicoes[tipoCond];
        let avaliacao = await processadorCondicao.avaliar({ dados, condicao });
        return avaliacao;
    }

    async processar({ fluxos, dados }) {
        for (const { tela, condicao } of fluxos) {
            const avaliacao = await this.avaliarCondicao({ condicao, dados });
            if (avaliacao) {
                return tela;
            }
        }
        return "#final";
    }
}
